import { p as It } from "../../styled-components.browser.esm-DBaC0ZEI.mjs";
import { _ as F, w as G, z as ke, v as W, p as Re, q as j, f as h, o as B, B as it, E as dt, e as st, a6 as x, d as lt, i as oe, t as Ne, P as Lt, g as Rt, m as _t, b as At, c as Ht, u as Y, a as ct, n as Ft } from "../../index-CjjiqU7h.mjs";
import { K as ue, i as Bt } from "../../motion-P3tHGbiP.mjs";
import { p as ut } from "../../pickAttrs-bNG7_x1p.mjs";
import * as b from "react";
import Z from "react";
import { L as jt } from "../../List-Bf4pLkNs.mjs";
import { t as Vt } from "../../toArray-C1Af_up9.mjs";
import { o as qt } from "../../omit-B_u6A-HL.mjs";
import { A as de } from "../../AntdIcon-EfV3m8Ts.mjs";
import { K as zt } from "../../Keyframes-2v50Jp-S.mjs";
import { g as Ut } from "../../index-BZFW3CAo.mjs";
import { g as Gt } from "../../collapse-Dt2ZKH64.mjs";
import { L as Wt } from "../../LoadingOutlined-CwpxM4LT.mjs";
import { c as ze } from "../../reactNode-CwSzDQK_.mjs";
function V(a, r) {
  return a[r];
}
var Xt = ["children"];
function ft(a, r) {
  return "".concat(a, "-").concat(r);
}
function Yt(a) {
  return a && a.type && a.type.isTreeNode;
}
function me(a, r) {
  return a ?? r;
}
function fe(a) {
  var r = a || {}, i = r.title, e = r._title, d = r.key, s = r.children, u = i || "title";
  return {
    title: u,
    _title: e || [u],
    key: d || "key",
    children: s || "children"
  };
}
function Jt(a, r) {
  var i = /* @__PURE__ */ new Map();
  function e(d) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (d || []).forEach(function(u) {
      var t = u[r.key], n = u[r.children];
      G(t != null, "Tree node must have a certain key: [".concat(s).concat(t, "]"));
      var o = String(t);
      G(!i.has(o) || t === null || t === void 0, "Same 'key' exist in the Tree: ".concat(o)), i.set(o, !0), e(n, "".concat(s).concat(o, " > "));
    });
  }
  e(a);
}
function pt(a) {
  function r(i) {
    var e = Vt(i);
    return e.map(function(d) {
      if (!Yt(d))
        return G(!d, "Tree/TreeNode can only accept TreeNode as children."), null;
      var s = d.key, u = d.props, t = u.children, n = ke(u, Xt), o = F({
        key: s
      }, n), l = r(t);
      return l.length && (o.children = l), o;
    }).filter(function(d) {
      return d;
    });
  }
  return r(a);
}
function Oe(a, r, i) {
  var e = fe(i), d = e._title, s = e.key, u = e.children, t = new Set(r === !0 ? [] : r), n = [];
  function o(l) {
    var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return l.map(function(f, v) {
      for (var g = ft(c ? c.pos : "0", v), y = me(f[s], g), p, m = 0; m < d.length; m += 1) {
        var k = d[m];
        if (f[k] !== void 0) {
          p = f[k];
          break;
        }
      }
      var K = Object.assign(qt(f, [].concat(W(d), [s, u])), {
        title: p,
        key: y,
        parent: c,
        pos: g,
        children: null,
        data: f,
        isStart: [].concat(W(c ? c.isStart : []), [v === 0]),
        isEnd: [].concat(W(c ? c.isEnd : []), [v === l.length - 1])
      });
      return n.push(K), r === !0 || t.has(y) ? K.children = o(f[u] || [], K) : K.children = [], K;
    });
  }
  return o(a), n;
}
function Qt(a, r, i) {
  var e = {};
  Re(i) === "object" ? e = i : e = {
    externalGetKey: i
  }, e = e || {};
  var d = e, s = d.childrenPropName, u = d.externalGetKey, t = d.fieldNames, n = fe(t), o = n.key, l = n.children, c = s || l, f;
  u ? typeof u == "string" ? f = function(y) {
    return y[u];
  } : typeof u == "function" && (f = function(y) {
    return u(y);
  }) : f = function(y, p) {
    return me(y[o], p);
  };
  function v(g, y, p, m) {
    var k = g ? g[c] : a, K = g ? ft(p.pos, y) : "0", N = g ? [].concat(W(m), [g]) : [];
    if (g) {
      var E = f(g, K), w = {
        node: g,
        index: y,
        pos: K,
        key: E,
        parentPos: p.node ? p.pos : null,
        level: p.level + 1,
        nodes: N
      };
      r(w);
    }
    k && k.forEach(function(P, D) {
      v(P, D, {
        node: g,
        pos: K,
        level: p ? p.level + 1 : -1
      }, N);
    });
  }
  v(null);
}
function vt(a) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = r.initWrapper, e = r.processEntity, d = r.onProcessFinished, s = r.externalGetKey, u = r.childrenPropName, t = r.fieldNames, n = arguments.length > 2 ? arguments[2] : void 0, o = s || n, l = {}, c = {}, f = {
    posEntities: l,
    keyEntities: c
  };
  return i && (f = i(f) || f), Qt(a, function(v) {
    var g = v.node, y = v.index, p = v.pos, m = v.key, k = v.parentPos, K = v.level, N = v.nodes, E = {
      node: g,
      nodes: N,
      index: y,
      key: m,
      pos: p,
      level: K
    }, w = me(m, p);
    l[p] = E, c[w] = E, E.parent = l[k], E.parent && (E.parent.children = E.parent.children || [], E.parent.children.push(E)), e && e(E, f);
  }, {
    externalGetKey: o,
    childrenPropName: u,
    fieldNames: t
  }), d && d(f), f;
}
function ye(a, r) {
  var i = r.expandedKeys, e = r.selectedKeys, d = r.loadedKeys, s = r.loadingKeys, u = r.checkedKeys, t = r.halfCheckedKeys, n = r.dragOverNodeKey, o = r.dropPosition, l = r.keyEntities, c = V(l, a), f = {
    eventKey: a,
    expanded: i.indexOf(a) !== -1,
    selected: e.indexOf(a) !== -1,
    loaded: d.indexOf(a) !== -1,
    loading: s.indexOf(a) !== -1,
    checked: u.indexOf(a) !== -1,
    halfChecked: t.indexOf(a) !== -1,
    pos: String(c ? c.pos : ""),
    // [Legacy] Drag props
    // Since the interaction of drag is changed, the semantic of the props are
    // not accuracy, I think it should be finally removed
    dragOver: n === a && o === 0,
    dragOverGapTop: n === a && o === -1,
    dragOverGapBottom: n === a && o === 1
  };
  return f;
}
function A(a) {
  var r = a.data, i = a.expanded, e = a.selected, d = a.checked, s = a.loaded, u = a.loading, t = a.halfChecked, n = a.dragOver, o = a.dragOverGapTop, l = a.dragOverGapBottom, c = a.pos, f = a.active, v = a.eventKey, g = F(F({}, r), {}, {
    expanded: i,
    selected: e,
    checked: d,
    loaded: s,
    loading: u,
    halfChecked: t,
    dragOver: n,
    dragOverGapTop: o,
    dragOverGapBottom: l,
    pos: c,
    active: f,
    key: v
  });
  return "props" in g || Object.defineProperty(g, "props", {
    get: function() {
      return G(!1, "Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`."), a;
    }
  }), g;
}
function gt(a, r) {
  var i = /* @__PURE__ */ new Set();
  return a.forEach(function(e) {
    r.has(e) || i.add(e);
  }), i;
}
function Zt(a) {
  var r = a || {}, i = r.disabled, e = r.disableCheckbox, d = r.checkable;
  return !!(i || e) || d === !1;
}
function en(a, r, i, e) {
  for (var d = new Set(a), s = /* @__PURE__ */ new Set(), u = 0; u <= i; u += 1) {
    var t = r.get(u) || /* @__PURE__ */ new Set();
    t.forEach(function(c) {
      var f = c.key, v = c.node, g = c.children, y = g === void 0 ? [] : g;
      d.has(f) && !e(v) && y.filter(function(p) {
        return !e(p.node);
      }).forEach(function(p) {
        d.add(p.key);
      });
    });
  }
  for (var n = /* @__PURE__ */ new Set(), o = i; o >= 0; o -= 1) {
    var l = r.get(o) || /* @__PURE__ */ new Set();
    l.forEach(function(c) {
      var f = c.parent, v = c.node;
      if (!(e(v) || !c.parent || n.has(c.parent.key))) {
        if (e(c.parent.node)) {
          n.add(f.key);
          return;
        }
        var g = !0, y = !1;
        (f.children || []).filter(function(p) {
          return !e(p.node);
        }).forEach(function(p) {
          var m = p.key, k = d.has(m);
          g && !k && (g = !1), !y && (k || s.has(m)) && (y = !0);
        }), g && d.add(f.key), y && s.add(f.key), n.add(f.key);
      }
    });
  }
  return {
    checkedKeys: Array.from(d),
    halfCheckedKeys: Array.from(gt(s, d))
  };
}
function tn(a, r, i, e, d) {
  for (var s = new Set(a), u = new Set(r), t = 0; t <= e; t += 1) {
    var n = i.get(t) || /* @__PURE__ */ new Set();
    n.forEach(function(f) {
      var v = f.key, g = f.node, y = f.children, p = y === void 0 ? [] : y;
      !s.has(v) && !u.has(v) && !d(g) && p.filter(function(m) {
        return !d(m.node);
      }).forEach(function(m) {
        s.delete(m.key);
      });
    });
  }
  u = /* @__PURE__ */ new Set();
  for (var o = /* @__PURE__ */ new Set(), l = e; l >= 0; l -= 1) {
    var c = i.get(l) || /* @__PURE__ */ new Set();
    c.forEach(function(f) {
      var v = f.parent, g = f.node;
      if (!(d(g) || !f.parent || o.has(f.parent.key))) {
        if (d(f.parent.node)) {
          o.add(v.key);
          return;
        }
        var y = !0, p = !1;
        (v.children || []).filter(function(m) {
          return !d(m.node);
        }).forEach(function(m) {
          var k = m.key, K = s.has(k);
          y && !K && (y = !1), !p && (K || u.has(k)) && (p = !0);
        }), y || s.delete(v.key), p && u.add(v.key), o.add(v.key);
      }
    });
  }
  return {
    checkedKeys: Array.from(s),
    halfCheckedKeys: Array.from(gt(u, s))
  };
}
function $e(a, r, i, e) {
  var d = [], s;
  e ? s = e : s = Zt;
  var u = new Set(a.filter(function(l) {
    var c = !!V(i, l);
    return c || d.push(l), c;
  })), t = /* @__PURE__ */ new Map(), n = 0;
  Object.keys(i).forEach(function(l) {
    var c = i[l], f = c.level, v = t.get(f);
    v || (v = /* @__PURE__ */ new Set(), t.set(f, v)), v.add(c), n = Math.max(n, f);
  }), G(!d.length, "Tree missing follow keys: ".concat(d.slice(0, 100).map(function(l) {
    return "'".concat(l, "'");
  }).join(", ")));
  var o;
  return r === !0 ? o = en(u, t, n, s) : o = tn(u, r.halfCheckedKeys, t, n, s), o;
}
var _e = /* @__PURE__ */ b.createContext(null), nn = function(r) {
  for (var i = r.prefixCls, e = r.level, d = r.isStart, s = r.isEnd, u = "".concat(i, "-indent-unit"), t = [], n = 0; n < e; n += 1)
    t.push(/* @__PURE__ */ b.createElement("span", {
      key: n,
      className: j(u, h(h({}, "".concat(u, "-start"), d[n]), "".concat(u, "-end"), s[n]))
    }));
  return /* @__PURE__ */ b.createElement("span", {
    "aria-hidden": "true",
    className: "".concat(i, "-indent")
  }, t);
};
const rn = /* @__PURE__ */ b.memo(nn);
var an = ["eventKey", "className", "style", "dragOver", "dragOverGapTop", "dragOverGapBottom", "isLeaf", "isStart", "isEnd", "expanded", "selected", "checked", "halfChecked", "loading", "domRef", "active", "data", "onMouseMove", "selectable"], Ue = "open", Ge = "close", on = "---", dn = /* @__PURE__ */ function(a) {
  it(i, a);
  var r = dt(i);
  function i() {
    var e;
    st(this, i);
    for (var d = arguments.length, s = new Array(d), u = 0; u < d; u++)
      s[u] = arguments[u];
    return e = r.call.apply(r, [this].concat(s)), h(x(e), "state", {
      dragNodeHighlight: !1
    }), h(x(e), "selectHandle", void 0), h(x(e), "cacheIndent", void 0), h(x(e), "onSelectorClick", function(t) {
      var n = e.props.context.onNodeClick;
      n(t, A(e.props)), e.isSelectable() ? e.onSelect(t) : e.onCheck(t);
    }), h(x(e), "onSelectorDoubleClick", function(t) {
      var n = e.props.context.onNodeDoubleClick;
      n(t, A(e.props));
    }), h(x(e), "onSelect", function(t) {
      if (!e.isDisabled()) {
        var n = e.props.context.onNodeSelect;
        n(t, A(e.props));
      }
    }), h(x(e), "onCheck", function(t) {
      if (!e.isDisabled()) {
        var n = e.props, o = n.disableCheckbox, l = n.checked, c = e.props.context.onNodeCheck;
        if (!(!e.isCheckable() || o)) {
          var f = !l;
          c(t, A(e.props), f);
        }
      }
    }), h(x(e), "onMouseEnter", function(t) {
      var n = e.props.context.onNodeMouseEnter;
      n(t, A(e.props));
    }), h(x(e), "onMouseLeave", function(t) {
      var n = e.props.context.onNodeMouseLeave;
      n(t, A(e.props));
    }), h(x(e), "onContextMenu", function(t) {
      var n = e.props.context.onNodeContextMenu;
      n(t, A(e.props));
    }), h(x(e), "onDragStart", function(t) {
      var n = e.props.context.onNodeDragStart;
      t.stopPropagation(), e.setState({
        dragNodeHighlight: !0
      }), n(t, x(e));
      try {
        t.dataTransfer.setData("text/plain", "");
      } catch {
      }
    }), h(x(e), "onDragEnter", function(t) {
      var n = e.props.context.onNodeDragEnter;
      t.preventDefault(), t.stopPropagation(), n(t, x(e));
    }), h(x(e), "onDragOver", function(t) {
      var n = e.props.context.onNodeDragOver;
      t.preventDefault(), t.stopPropagation(), n(t, x(e));
    }), h(x(e), "onDragLeave", function(t) {
      var n = e.props.context.onNodeDragLeave;
      t.stopPropagation(), n(t, x(e));
    }), h(x(e), "onDragEnd", function(t) {
      var n = e.props.context.onNodeDragEnd;
      t.stopPropagation(), e.setState({
        dragNodeHighlight: !1
      }), n(t, x(e));
    }), h(x(e), "onDrop", function(t) {
      var n = e.props.context.onNodeDrop;
      t.preventDefault(), t.stopPropagation(), e.setState({
        dragNodeHighlight: !1
      }), n(t, x(e));
    }), h(x(e), "onExpand", function(t) {
      var n = e.props, o = n.loading, l = n.context.onNodeExpand;
      o || l(t, A(e.props));
    }), h(x(e), "setSelectHandle", function(t) {
      e.selectHandle = t;
    }), h(x(e), "getNodeState", function() {
      var t = e.props.expanded;
      return e.isLeaf() ? null : t ? Ue : Ge;
    }), h(x(e), "hasChildren", function() {
      var t = e.props.eventKey, n = e.props.context.keyEntities, o = V(n, t) || {}, l = o.children;
      return !!(l || []).length;
    }), h(x(e), "isLeaf", function() {
      var t = e.props, n = t.isLeaf, o = t.loaded, l = e.props.context.loadData, c = e.hasChildren();
      return n === !1 ? !1 : n || !l && !c || l && o && !c;
    }), h(x(e), "isDisabled", function() {
      var t = e.props.disabled, n = e.props.context.disabled;
      return !!(n || t);
    }), h(x(e), "isCheckable", function() {
      var t = e.props.checkable, n = e.props.context.checkable;
      return !n || t === !1 ? !1 : n;
    }), h(x(e), "syncLoadData", function(t) {
      var n = t.expanded, o = t.loading, l = t.loaded, c = e.props.context, f = c.loadData, v = c.onNodeLoad;
      o || f && n && !e.isLeaf() && !l && v(A(e.props));
    }), h(x(e), "isDraggable", function() {
      var t = e.props, n = t.data, o = t.context.draggable;
      return !!(o && (!o.nodeDraggable || o.nodeDraggable(n)));
    }), h(x(e), "renderDragHandler", function() {
      var t = e.props.context, n = t.draggable, o = t.prefixCls;
      return n != null && n.icon ? /* @__PURE__ */ b.createElement("span", {
        className: "".concat(o, "-draggable-icon")
      }, n.icon) : null;
    }), h(x(e), "renderSwitcherIconDom", function(t) {
      var n = e.props.switcherIcon, o = e.props.context.switcherIcon, l = n || o;
      return typeof l == "function" ? l(F(F({}, e.props), {}, {
        isLeaf: t
      })) : l;
    }), h(x(e), "renderSwitcher", function() {
      var t = e.props.expanded, n = e.props.context.prefixCls;
      if (e.isLeaf()) {
        var o = e.renderSwitcherIconDom(!0);
        return o !== !1 ? /* @__PURE__ */ b.createElement("span", {
          className: j("".concat(n, "-switcher"), "".concat(n, "-switcher-noop"))
        }, o) : null;
      }
      var l = j("".concat(n, "-switcher"), "".concat(n, "-switcher_").concat(t ? Ue : Ge)), c = e.renderSwitcherIconDom(!1);
      return c !== !1 ? /* @__PURE__ */ b.createElement("span", {
        onClick: e.onExpand,
        className: l
      }, c) : null;
    }), h(x(e), "renderCheckbox", function() {
      var t = e.props, n = t.checked, o = t.halfChecked, l = t.disableCheckbox, c = e.props.context.prefixCls, f = e.isDisabled(), v = e.isCheckable();
      if (!v)
        return null;
      var g = typeof v != "boolean" ? v : null;
      return /* @__PURE__ */ b.createElement("span", {
        className: j("".concat(c, "-checkbox"), n && "".concat(c, "-checkbox-checked"), !n && o && "".concat(c, "-checkbox-indeterminate"), (f || l) && "".concat(c, "-checkbox-disabled")),
        onClick: e.onCheck
      }, g);
    }), h(x(e), "renderIcon", function() {
      var t = e.props.loading, n = e.props.context.prefixCls;
      return /* @__PURE__ */ b.createElement("span", {
        className: j("".concat(n, "-iconEle"), "".concat(n, "-icon__").concat(e.getNodeState() || "docu"), t && "".concat(n, "-icon_loading"))
      });
    }), h(x(e), "renderSelector", function() {
      var t = e.state.dragNodeHighlight, n = e.props, o = n.title, l = o === void 0 ? on : o, c = n.selected, f = n.icon, v = n.loading, g = n.data, y = e.props.context, p = y.prefixCls, m = y.showIcon, k = y.icon, K = y.loadData, N = y.titleRender, E = e.isDisabled(), w = "".concat(p, "-node-content-wrapper"), P;
      if (m) {
        var D = f || k;
        P = D ? /* @__PURE__ */ b.createElement("span", {
          className: j("".concat(p, "-iconEle"), "".concat(p, "-icon__customize"))
        }, typeof D == "function" ? D(e.props) : D) : e.renderIcon();
      } else
        K && v && (P = e.renderIcon());
      var C;
      typeof l == "function" ? C = l(g) : N ? C = N(g) : C = l;
      var S = /* @__PURE__ */ b.createElement("span", {
        className: "".concat(p, "-title")
      }, C);
      return /* @__PURE__ */ b.createElement("span", {
        ref: e.setSelectHandle,
        title: typeof l == "string" ? l : "",
        className: j("".concat(w), "".concat(w, "-").concat(e.getNodeState() || "normal"), !E && (c || t) && "".concat(p, "-node-selected")),
        onMouseEnter: e.onMouseEnter,
        onMouseLeave: e.onMouseLeave,
        onContextMenu: e.onContextMenu,
        onClick: e.onSelectorClick,
        onDoubleClick: e.onSelectorDoubleClick
      }, P, S, e.renderDropIndicator());
    }), h(x(e), "renderDropIndicator", function() {
      var t = e.props, n = t.disabled, o = t.eventKey, l = e.props.context, c = l.draggable, f = l.dropLevelOffset, v = l.dropPosition, g = l.prefixCls, y = l.indent, p = l.dropIndicatorRender, m = l.dragOverNodeKey, k = l.direction, K = !!c, N = !n && K && m === o, E = y ?? e.cacheIndent;
      return e.cacheIndent = y, N ? p({
        dropPosition: v,
        dropLevelOffset: f,
        indent: E,
        prefixCls: g,
        direction: k
      }) : null;
    }), e;
  }
  return lt(i, [{
    key: "componentDidMount",
    value: (
      // Isomorphic needn't load data in server side
      function() {
        this.syncLoadData(this.props);
      }
    )
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.syncLoadData(this.props);
    }
  }, {
    key: "isSelectable",
    value: function() {
      var d = this.props.selectable, s = this.props.context.selectable;
      return typeof d == "boolean" ? d : s;
    }
  }, {
    key: "render",
    value: (
      // =========================== Render ===========================
      function() {
        var d, s = this.props, u = s.eventKey, t = s.className, n = s.style, o = s.dragOver, l = s.dragOverGapTop, c = s.dragOverGapBottom, f = s.isLeaf, v = s.isStart, g = s.isEnd, y = s.expanded, p = s.selected, m = s.checked, k = s.halfChecked, K = s.loading, N = s.domRef, E = s.active;
        s.data;
        var w = s.onMouseMove, P = s.selectable, D = ke(s, an), C = this.props.context, S = C.prefixCls, T = C.filterTreeNode, O = C.keyEntities, I = C.dropContainerKey, $ = C.dropTargetKey, L = C.draggingNodeKey, R = this.isDisabled(), M = ut(D, {
          aria: !0,
          data: !0
        }), q = V(O, u) || {}, ee = q.level, H = g[g.length - 1], z = this.isDraggable(), U = !R && z, te = L === u, ve = P !== void 0 ? {
          "aria-selected": !!P
        } : void 0;
        return /* @__PURE__ */ b.createElement("div", B({
          ref: N,
          className: j(t, "".concat(S, "-treenode"), (d = {}, h(h(h(h(h(h(h(h(h(h(d, "".concat(S, "-treenode-disabled"), R), "".concat(S, "-treenode-switcher-").concat(y ? "open" : "close"), !f), "".concat(S, "-treenode-checkbox-checked"), m), "".concat(S, "-treenode-checkbox-indeterminate"), k), "".concat(S, "-treenode-selected"), p), "".concat(S, "-treenode-loading"), K), "".concat(S, "-treenode-active"), E), "".concat(S, "-treenode-leaf-last"), H), "".concat(S, "-treenode-draggable"), z), "dragging", te), h(h(h(h(h(h(d, "drop-target", $ === u), "drop-container", I === u), "drag-over", !R && o), "drag-over-gap-top", !R && l), "drag-over-gap-bottom", !R && c), "filter-node", T && T(A(this.props))))),
          style: n,
          draggable: U,
          "aria-grabbed": te,
          onDragStart: U ? this.onDragStart : void 0,
          onDragEnter: z ? this.onDragEnter : void 0,
          onDragOver: z ? this.onDragOver : void 0,
          onDragLeave: z ? this.onDragLeave : void 0,
          onDrop: z ? this.onDrop : void 0,
          onDragEnd: z ? this.onDragEnd : void 0,
          onMouseMove: w
        }, ve, M), /* @__PURE__ */ b.createElement(rn, {
          prefixCls: S,
          level: ee,
          isStart: v,
          isEnd: g
        }), this.renderDragHandler(), this.renderSwitcher(), this.renderCheckbox(), this.renderSelector());
      }
    )
  }]), i;
}(b.Component), pe = function(r) {
  return /* @__PURE__ */ b.createElement(_e.Consumer, null, function(i) {
    return /* @__PURE__ */ b.createElement(dn, B({}, r, {
      context: i
    }));
  });
};
pe.displayName = "TreeNode";
pe.isTreeNode = 1;
function X(a, r) {
  if (!a)
    return [];
  var i = a.slice(), e = i.indexOf(r);
  return e >= 0 && i.splice(e, 1), i;
}
function Q(a, r) {
  var i = (a || []).slice();
  return i.indexOf(r) === -1 && i.push(r), i;
}
function Ae(a) {
  return a.split("-");
}
function sn(a, r) {
  var i = [], e = V(r, a);
  function d() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    s.forEach(function(u) {
      var t = u.key, n = u.children;
      i.push(t), d(n);
    });
  }
  return d(e.children), i;
}
function ln(a) {
  if (a.parent) {
    var r = Ae(a.pos);
    return Number(r[r.length - 1]) === a.parent.children.length - 1;
  }
  return !1;
}
function cn(a) {
  var r = Ae(a.pos);
  return Number(r[r.length - 1]) === 0;
}
function We(a, r, i, e, d, s, u, t, n, o) {
  var l, c = a.clientX, f = a.clientY, v = a.target.getBoundingClientRect(), g = v.top, y = v.height, p = (o === "rtl" ? -1 : 1) * (((d == null ? void 0 : d.x) || 0) - c), m = (p - 12) / e, k = n.filter(function(R) {
    var M;
    return (M = t[R]) === null || M === void 0 || (M = M.children) === null || M === void 0 ? void 0 : M.length;
  }), K = V(t, i.props.eventKey);
  if (f < g + y / 2) {
    var N = u.findIndex(function(R) {
      return R.key === K.key;
    }), E = N <= 0 ? 0 : N - 1, w = u[E].key;
    K = V(t, w);
  }
  var P = K.key, D = K, C = K.key, S = 0, T = 0;
  if (!k.includes(P))
    for (var O = 0; O < m && ln(K); O += 1)
      K = K.parent, T += 1;
  var I = r.props.data, $ = K.node, L = !0;
  return cn(K) && K.level === 0 && f < g + y / 2 && s({
    dragNode: I,
    dropNode: $,
    dropPosition: -1
  }) && K.key === i.props.eventKey ? S = -1 : (D.children || []).length && k.includes(C) ? s({
    dragNode: I,
    dropNode: $,
    dropPosition: 0
  }) ? S = 0 : L = !1 : T === 0 ? m > -1.5 ? s({
    dragNode: I,
    dropNode: $,
    dropPosition: 1
  }) ? S = 1 : L = !1 : s({
    dragNode: I,
    dropNode: $,
    dropPosition: 0
  }) ? S = 0 : s({
    dragNode: I,
    dropNode: $,
    dropPosition: 1
  }) ? S = 1 : L = !1 : s({
    dragNode: I,
    dropNode: $,
    dropPosition: 1
  }) ? S = 1 : L = !1, {
    dropPosition: S,
    dropLevelOffset: T,
    dropTargetKey: K.key,
    dropTargetPos: K.pos,
    dragOverNodeKey: C,
    dropContainerKey: S === 0 ? null : ((l = K.parent) === null || l === void 0 ? void 0 : l.key) || null,
    dropAllowed: L
  };
}
function Xe(a, r) {
  if (a) {
    var i = r.multiple;
    return i ? a.slice() : a.length ? [a[0]] : a;
  }
}
function Pe(a) {
  if (!a)
    return null;
  var r;
  if (Array.isArray(a))
    r = {
      checkedKeys: a,
      halfCheckedKeys: void 0
    };
  else if (Re(a) === "object")
    r = {
      checkedKeys: a.checked || void 0,
      halfCheckedKeys: a.halfChecked || void 0
    };
  else
    return G(!1, "`checkedKeys` is not an array or an object"), null;
  return r;
}
function Ie(a, r) {
  var i = /* @__PURE__ */ new Set();
  function e(d) {
    if (!i.has(d)) {
      var s = V(r, d);
      if (s) {
        i.add(d);
        var u = s.parent, t = s.node;
        t.disabled || u && e(u.key);
      }
    }
  }
  return (a || []).forEach(function(d) {
    e(d);
  }), W(i);
}
function un(a) {
  var r = a.dropPosition, i = a.dropLevelOffset, e = a.indent, d = {
    pointerEvents: "none",
    position: "absolute",
    right: 0,
    backgroundColor: "red",
    height: 2
  };
  switch (r) {
    case -1:
      d.top = 0, d.left = -i * e;
      break;
    case 1:
      d.bottom = 0, d.left = -i * e;
      break;
    case 0:
      d.bottom = 0, d.left = e;
      break;
  }
  return /* @__PURE__ */ b.createElement("div", {
    style: d
  });
}
function ht(a) {
  if (a == null)
    throw new TypeError("Cannot destructure " + a);
}
function fn(a, r) {
  var i = b.useState(!1), e = oe(i, 2), d = e[0], s = e[1];
  Ne(function() {
    if (d)
      return a(), function() {
        r();
      };
  }, [d]), Ne(function() {
    return s(!0), function() {
      s(!1);
    };
  }, []);
}
var pn = ["className", "style", "motion", "motionNodes", "motionType", "onMotionStart", "onMotionEnd", "active", "treeNodeRequiredProps"], yt = function(r, i) {
  var e = r.className, d = r.style, s = r.motion, u = r.motionNodes, t = r.motionType, n = r.onMotionStart, o = r.onMotionEnd, l = r.active, c = r.treeNodeRequiredProps, f = ke(r, pn), v = b.useState(!0), g = oe(v, 2), y = g[0], p = g[1], m = b.useContext(_e), k = m.prefixCls, K = u && t !== "hide";
  Ne(function() {
    u && K !== y && p(K);
  }, [u]);
  var N = function() {
    u && n();
  }, E = b.useRef(!1), w = function() {
    u && !E.current && (E.current = !0, o());
  };
  fn(N, w);
  var P = function(C) {
    K === C && w();
  };
  return u ? /* @__PURE__ */ b.createElement(Lt, B({
    ref: i,
    visible: y
  }, s, {
    motionAppear: t === "show",
    onVisibleChanged: P
  }), function(D, C) {
    var S = D.className, T = D.style;
    return /* @__PURE__ */ b.createElement("div", {
      ref: C,
      className: j("".concat(k, "-treenode-motion"), S),
      style: T
    }, u.map(function(O) {
      var I = Object.assign({}, (ht(O.data), O.data)), $ = O.title, L = O.key, R = O.isStart, M = O.isEnd;
      delete I.children;
      var q = ye(L, c);
      return /* @__PURE__ */ b.createElement(pe, B({}, I, q, {
        title: $,
        active: l,
        data: O.data,
        key: L,
        isStart: R,
        isEnd: M
      }));
    }));
  }) : /* @__PURE__ */ b.createElement(pe, B({
    domRef: i,
    className: e,
    style: d
  }, f, {
    active: l
  }));
};
yt.displayName = "MotionTreeNode";
var vn = /* @__PURE__ */ b.forwardRef(yt);
function gn() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = a.length, e = r.length;
  if (Math.abs(i - e) !== 1)
    return {
      add: !1,
      key: null
    };
  function d(s, u) {
    var t = /* @__PURE__ */ new Map();
    s.forEach(function(o) {
      t.set(o, !0);
    });
    var n = u.filter(function(o) {
      return !t.has(o);
    });
    return n.length === 1 ? n[0] : null;
  }
  return i < e ? {
    add: !0,
    key: d(a, r)
  } : {
    add: !1,
    key: d(r, a)
  };
}
function Ye(a, r, i) {
  var e = a.findIndex(function(t) {
    return t.key === i;
  }), d = a[e + 1], s = r.findIndex(function(t) {
    return t.key === i;
  });
  if (d) {
    var u = r.findIndex(function(t) {
      return t.key === d.key;
    });
    return r.slice(s + 1, u);
  }
  return r.slice(s + 1);
}
var hn = ["prefixCls", "data", "selectable", "checkable", "expandedKeys", "selectedKeys", "checkedKeys", "loadedKeys", "loadingKeys", "halfCheckedKeys", "keyEntities", "disabled", "dragging", "dragOverNodeKey", "dropPosition", "motion", "height", "itemHeight", "virtual", "focusable", "activeItem", "focused", "tabIndex", "onKeyDown", "onFocus", "onBlur", "onActiveChange", "onListChangeStart", "onListChangeEnd"], Je = {
  width: 0,
  height: 0,
  display: "flex",
  overflow: "hidden",
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
}, yn = function() {
}, ie = "RC_TREE_MOTION_".concat(Math.random()), Le = {
  key: ie
}, mt = {
  key: ie,
  level: 0,
  index: 0,
  pos: "0",
  node: Le,
  nodes: [Le]
}, Qe = {
  parent: null,
  children: [],
  pos: mt.pos,
  data: Le,
  title: null,
  key: ie,
  /** Hold empty list here since we do not use it */
  isStart: [],
  isEnd: []
};
function Ze(a, r, i, e) {
  return r === !1 || !i ? a : a.slice(0, Math.ceil(i / e) + 1);
}
function et(a) {
  var r = a.key, i = a.pos;
  return me(r, i);
}
function mn(a) {
  for (var r = String(a.data.key), i = a; i.parent; )
    i = i.parent, r = "".concat(i.data.key, " > ").concat(r);
  return r;
}
var bt = /* @__PURE__ */ b.forwardRef(function(a, r) {
  var i = a.prefixCls, e = a.data;
  a.selectable, a.checkable;
  var d = a.expandedKeys, s = a.selectedKeys, u = a.checkedKeys, t = a.loadedKeys, n = a.loadingKeys, o = a.halfCheckedKeys, l = a.keyEntities, c = a.disabled, f = a.dragging, v = a.dragOverNodeKey, g = a.dropPosition, y = a.motion, p = a.height, m = a.itemHeight, k = a.virtual, K = a.focusable, N = a.activeItem, E = a.focused, w = a.tabIndex, P = a.onKeyDown, D = a.onFocus, C = a.onBlur, S = a.onActiveChange, T = a.onListChangeStart, O = a.onListChangeEnd, I = ke(a, hn), $ = b.useRef(null), L = b.useRef(null);
  b.useImperativeHandle(r, function() {
    return {
      scrollTo: function(J) {
        $.current.scrollTo(J);
      },
      getIndentWidth: function() {
        return L.current.offsetWidth;
      }
    };
  });
  var R = b.useState(d), M = oe(R, 2), q = M[0], ee = M[1], H = b.useState(e), z = oe(H, 2), U = z[0], te = z[1], ve = b.useState(e), be = oe(ve, 2), Ee = be[0], se = be[1], Ce = b.useState([]), Ke = oe(Ce, 2), le = Ke[0], Se = Ke[1], Pt = b.useState(null), je = oe(Pt, 2), Tt = je[0], De = je[1], Ve = b.useRef(e);
  Ve.current = e;
  function we() {
    var _ = Ve.current;
    te(_), se(_), Se([]), De(null), O();
  }
  Ne(function() {
    ee(d);
    var _ = gn(q, d);
    if (_.key !== null)
      if (_.add) {
        var J = U.findIndex(function(ge) {
          var he = ge.key;
          return he === _.key;
        }), ne = Ze(Ye(U, e, _.key), k, p, m), ce = U.slice();
        ce.splice(J + 1, 0, Qe), se(ce), Se(ne), De("show");
      } else {
        var re = e.findIndex(function(ge) {
          var he = ge.key;
          return he === _.key;
        }), ae = Ze(Ye(e, U, _.key), k, p, m), xe = e.slice();
        xe.splice(re + 1, 0, Qe), se(xe), Se(ae), De("hide");
      }
    else
      U !== e && (te(e), se(e));
  }, [d, e]), b.useEffect(function() {
    f || we();
  }, [f]);
  var Mt = y ? Ee : e, qe = {
    expandedKeys: d,
    selectedKeys: s,
    loadedKeys: t,
    loadingKeys: n,
    checkedKeys: u,
    halfCheckedKeys: o,
    dragOverNodeKey: v,
    dropPosition: g,
    keyEntities: l
  };
  return /* @__PURE__ */ b.createElement(b.Fragment, null, E && N && /* @__PURE__ */ b.createElement("span", {
    style: Je,
    "aria-live": "assertive"
  }, mn(N)), /* @__PURE__ */ b.createElement("div", null, /* @__PURE__ */ b.createElement("input", {
    style: Je,
    disabled: K === !1 || c,
    tabIndex: K !== !1 ? w : null,
    onKeyDown: P,
    onFocus: D,
    onBlur: C,
    value: "",
    onChange: yn,
    "aria-label": "for screen reader"
  })), /* @__PURE__ */ b.createElement("div", {
    className: "".concat(i, "-treenode"),
    "aria-hidden": !0,
    style: {
      position: "absolute",
      pointerEvents: "none",
      visibility: "hidden",
      height: 0,
      overflow: "hidden",
      border: 0,
      padding: 0
    }
  }, /* @__PURE__ */ b.createElement("div", {
    className: "".concat(i, "-indent")
  }, /* @__PURE__ */ b.createElement("div", {
    ref: L,
    className: "".concat(i, "-indent-unit")
  }))), /* @__PURE__ */ b.createElement(jt, B({}, I, {
    data: Mt,
    itemKey: et,
    height: p,
    fullHeight: !1,
    virtual: k,
    itemHeight: m,
    prefixCls: "".concat(i, "-list"),
    ref: $,
    onVisibleChange: function(J, ne) {
      var ce = new Set(J), re = ne.filter(function(ae) {
        return !ce.has(ae);
      });
      re.some(function(ae) {
        return et(ae) === ie;
      }) && we();
    }
  }), function(_) {
    var J = _.pos, ne = Object.assign({}, (ht(_.data), _.data)), ce = _.title, re = _.key, ae = _.isStart, xe = _.isEnd, ge = me(re, J);
    delete ne.key, delete ne.children;
    var he = ye(ge, qe);
    return /* @__PURE__ */ b.createElement(vn, B({}, ne, he, {
      title: ce,
      active: !!N && re === N.key,
      pos: J,
      data: _.data,
      isStart: ae,
      isEnd: xe,
      motion: y,
      motionNodes: re === ie ? le : null,
      motionType: Tt,
      onMotionStart: T,
      onMotionEnd: we,
      treeNodeRequiredProps: qe,
      onMouseMove: function() {
        S(null);
      }
    }));
  }));
});
bt.displayName = "NodeList";
var bn = 10, He = /* @__PURE__ */ function(a) {
  it(i, a);
  var r = dt(i);
  function i() {
    var e;
    st(this, i);
    for (var d = arguments.length, s = new Array(d), u = 0; u < d; u++)
      s[u] = arguments[u];
    return e = r.call.apply(r, [this].concat(s)), h(x(e), "destroyed", !1), h(x(e), "delayedDragEnterLogic", void 0), h(x(e), "loadingRetryTimes", {}), h(x(e), "state", {
      keyEntities: {},
      indent: null,
      selectedKeys: [],
      checkedKeys: [],
      halfCheckedKeys: [],
      loadedKeys: [],
      loadingKeys: [],
      expandedKeys: [],
      draggingNodeKey: null,
      dragChildrenKeys: [],
      // dropTargetKey is the key of abstract-drop-node
      // the abstract-drop-node is the real drop node when drag and drop
      // not the DOM drag over node
      dropTargetKey: null,
      dropPosition: null,
      // the drop position of abstract-drop-node, inside 0, top -1, bottom 1
      dropContainerKey: null,
      // the container key of abstract-drop-node if dropPosition is -1 or 1
      dropLevelOffset: null,
      // the drop level offset of abstract-drag-over-node
      dropTargetPos: null,
      // the pos of abstract-drop-node
      dropAllowed: !0,
      // if drop to abstract-drop-node is allowed
      // the abstract-drag-over-node
      // if mouse is on the bottom of top dom node or no the top of the bottom dom node
      // abstract-drag-over-node is the top node
      dragOverNodeKey: null,
      treeData: [],
      flattenNodes: [],
      focused: !1,
      activeKey: null,
      listChanging: !1,
      prevProps: null,
      fieldNames: fe()
    }), h(x(e), "dragStartMousePosition", null), h(x(e), "dragNode", void 0), h(x(e), "currentMouseOverDroppableNodeKey", null), h(x(e), "listRef", /* @__PURE__ */ b.createRef()), h(x(e), "onNodeDragStart", function(t, n) {
      var o = e.state, l = o.expandedKeys, c = o.keyEntities, f = e.props.onDragStart, v = n.props.eventKey;
      e.dragNode = n, e.dragStartMousePosition = {
        x: t.clientX,
        y: t.clientY
      };
      var g = X(l, v);
      e.setState({
        draggingNodeKey: v,
        dragChildrenKeys: sn(v, c),
        indent: e.listRef.current.getIndentWidth()
      }), e.setExpandedKeys(g), window.addEventListener("dragend", e.onWindowDragEnd), f == null || f({
        event: t,
        node: A(n.props)
      });
    }), h(x(e), "onNodeDragEnter", function(t, n) {
      var o = e.state, l = o.expandedKeys, c = o.keyEntities, f = o.dragChildrenKeys, v = o.flattenNodes, g = o.indent, y = e.props, p = y.onDragEnter, m = y.onExpand, k = y.allowDrop, K = y.direction, N = n.props, E = N.pos, w = N.eventKey, P = x(e), D = P.dragNode;
      if (e.currentMouseOverDroppableNodeKey !== w && (e.currentMouseOverDroppableNodeKey = w), !D) {
        e.resetDragState();
        return;
      }
      var C = We(t, D, n, g, e.dragStartMousePosition, k, v, c, l, K), S = C.dropPosition, T = C.dropLevelOffset, O = C.dropTargetKey, I = C.dropContainerKey, $ = C.dropTargetPos, L = C.dropAllowed, R = C.dragOverNodeKey;
      if (
        // don't allow drop inside its children
        f.indexOf(O) !== -1 || // don't allow drop when drop is not allowed caculated by calcDropPosition
        !L
      ) {
        e.resetDragState();
        return;
      }
      if (e.delayedDragEnterLogic || (e.delayedDragEnterLogic = {}), Object.keys(e.delayedDragEnterLogic).forEach(function(M) {
        clearTimeout(e.delayedDragEnterLogic[M]);
      }), D.props.eventKey !== n.props.eventKey && (t.persist(), e.delayedDragEnterLogic[E] = window.setTimeout(function() {
        if (e.state.draggingNodeKey !== null) {
          var M = W(l), q = V(c, n.props.eventKey);
          q && (q.children || []).length && (M = Q(l, n.props.eventKey)), "expandedKeys" in e.props || e.setExpandedKeys(M), m == null || m(M, {
            node: A(n.props),
            expanded: !0,
            nativeEvent: t.nativeEvent
          });
        }
      }, 800)), D.props.eventKey === O && T === 0) {
        e.resetDragState();
        return;
      }
      e.setState({
        dragOverNodeKey: R,
        dropPosition: S,
        dropLevelOffset: T,
        dropTargetKey: O,
        dropContainerKey: I,
        dropTargetPos: $,
        dropAllowed: L
      }), p == null || p({
        event: t,
        node: A(n.props),
        expandedKeys: l
      });
    }), h(x(e), "onNodeDragOver", function(t, n) {
      var o = e.state, l = o.dragChildrenKeys, c = o.flattenNodes, f = o.keyEntities, v = o.expandedKeys, g = o.indent, y = e.props, p = y.onDragOver, m = y.allowDrop, k = y.direction, K = x(e), N = K.dragNode;
      if (N) {
        var E = We(t, N, n, g, e.dragStartMousePosition, m, c, f, v, k), w = E.dropPosition, P = E.dropLevelOffset, D = E.dropTargetKey, C = E.dropContainerKey, S = E.dropAllowed, T = E.dropTargetPos, O = E.dragOverNodeKey;
        l.indexOf(D) !== -1 || !S || (N.props.eventKey === D && P === 0 ? e.state.dropPosition === null && e.state.dropLevelOffset === null && e.state.dropTargetKey === null && e.state.dropContainerKey === null && e.state.dropTargetPos === null && e.state.dropAllowed === !1 && e.state.dragOverNodeKey === null || e.resetDragState() : w === e.state.dropPosition && P === e.state.dropLevelOffset && D === e.state.dropTargetKey && C === e.state.dropContainerKey && T === e.state.dropTargetPos && S === e.state.dropAllowed && O === e.state.dragOverNodeKey || e.setState({
          dropPosition: w,
          dropLevelOffset: P,
          dropTargetKey: D,
          dropContainerKey: C,
          dropTargetPos: T,
          dropAllowed: S,
          dragOverNodeKey: O
        }), p == null || p({
          event: t,
          node: A(n.props)
        }));
      }
    }), h(x(e), "onNodeDragLeave", function(t, n) {
      e.currentMouseOverDroppableNodeKey === n.props.eventKey && !t.currentTarget.contains(t.relatedTarget) && (e.resetDragState(), e.currentMouseOverDroppableNodeKey = null);
      var o = e.props.onDragLeave;
      o == null || o({
        event: t,
        node: A(n.props)
      });
    }), h(x(e), "onWindowDragEnd", function(t) {
      e.onNodeDragEnd(t, null, !0), window.removeEventListener("dragend", e.onWindowDragEnd);
    }), h(x(e), "onNodeDragEnd", function(t, n) {
      var o = e.props.onDragEnd;
      e.setState({
        dragOverNodeKey: null
      }), e.cleanDragState(), o == null || o({
        event: t,
        node: A(n.props)
      }), e.dragNode = null, window.removeEventListener("dragend", e.onWindowDragEnd);
    }), h(x(e), "onNodeDrop", function(t, n) {
      var o, l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, c = e.state, f = c.dragChildrenKeys, v = c.dropPosition, g = c.dropTargetKey, y = c.dropTargetPos, p = c.dropAllowed;
      if (p) {
        var m = e.props.onDrop;
        if (e.setState({
          dragOverNodeKey: null
        }), e.cleanDragState(), g !== null) {
          var k = F(F({}, ye(g, e.getTreeNodeRequiredProps())), {}, {
            active: ((o = e.getActiveItem()) === null || o === void 0 ? void 0 : o.key) === g,
            data: V(e.state.keyEntities, g).node
          }), K = f.indexOf(g) !== -1;
          G(!K, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
          var N = Ae(y), E = {
            event: t,
            node: A(k),
            dragNode: e.dragNode ? A(e.dragNode.props) : null,
            dragNodesKeys: [e.dragNode.props.eventKey].concat(f),
            dropToGap: v !== 0,
            dropPosition: v + Number(N[N.length - 1])
          };
          l || m == null || m(E), e.dragNode = null;
        }
      }
    }), h(x(e), "cleanDragState", function() {
      var t = e.state.draggingNodeKey;
      t !== null && e.setState({
        draggingNodeKey: null,
        dropPosition: null,
        dropContainerKey: null,
        dropTargetKey: null,
        dropLevelOffset: null,
        dropAllowed: !0,
        dragOverNodeKey: null
      }), e.dragStartMousePosition = null, e.currentMouseOverDroppableNodeKey = null;
    }), h(x(e), "triggerExpandActionExpand", function(t, n) {
      var o = e.state, l = o.expandedKeys, c = o.flattenNodes, f = n.expanded, v = n.key, g = n.isLeaf;
      if (!(g || t.shiftKey || t.metaKey || t.ctrlKey)) {
        var y = c.filter(function(m) {
          return m.key === v;
        })[0], p = A(F(F({}, ye(v, e.getTreeNodeRequiredProps())), {}, {
          data: y.data
        }));
        e.setExpandedKeys(f ? X(l, v) : Q(l, v)), e.onNodeExpand(t, p);
      }
    }), h(x(e), "onNodeClick", function(t, n) {
      var o = e.props, l = o.onClick, c = o.expandAction;
      c === "click" && e.triggerExpandActionExpand(t, n), l == null || l(t, n);
    }), h(x(e), "onNodeDoubleClick", function(t, n) {
      var o = e.props, l = o.onDoubleClick, c = o.expandAction;
      c === "doubleClick" && e.triggerExpandActionExpand(t, n), l == null || l(t, n);
    }), h(x(e), "onNodeSelect", function(t, n) {
      var o = e.state.selectedKeys, l = e.state, c = l.keyEntities, f = l.fieldNames, v = e.props, g = v.onSelect, y = v.multiple, p = n.selected, m = n[f.key], k = !p;
      k ? y ? o = Q(o, m) : o = [m] : o = X(o, m);
      var K = o.map(function(N) {
        var E = V(c, N);
        return E ? E.node : null;
      }).filter(function(N) {
        return N;
      });
      e.setUncontrolledState({
        selectedKeys: o
      }), g == null || g(o, {
        event: "select",
        selected: k,
        node: n,
        selectedNodes: K,
        nativeEvent: t.nativeEvent
      });
    }), h(x(e), "onNodeCheck", function(t, n, o) {
      var l = e.state, c = l.keyEntities, f = l.checkedKeys, v = l.halfCheckedKeys, g = e.props, y = g.checkStrictly, p = g.onCheck, m = n.key, k, K = {
        event: "check",
        node: n,
        checked: o,
        nativeEvent: t.nativeEvent
      };
      if (y) {
        var N = o ? Q(f, m) : X(f, m), E = X(v, m);
        k = {
          checked: N,
          halfChecked: E
        }, K.checkedNodes = N.map(function(T) {
          return V(c, T);
        }).filter(function(T) {
          return T;
        }).map(function(T) {
          return T.node;
        }), e.setUncontrolledState({
          checkedKeys: N
        });
      } else {
        var w = $e([].concat(W(f), [m]), !0, c), P = w.checkedKeys, D = w.halfCheckedKeys;
        if (!o) {
          var C = new Set(P);
          C.delete(m);
          var S = $e(Array.from(C), {
            checked: !1,
            halfCheckedKeys: D
          }, c);
          P = S.checkedKeys, D = S.halfCheckedKeys;
        }
        k = P, K.checkedNodes = [], K.checkedNodesPositions = [], K.halfCheckedKeys = D, P.forEach(function(T) {
          var O = V(c, T);
          if (O) {
            var I = O.node, $ = O.pos;
            K.checkedNodes.push(I), K.checkedNodesPositions.push({
              node: I,
              pos: $
            });
          }
        }), e.setUncontrolledState({
          checkedKeys: P
        }, !1, {
          halfCheckedKeys: D
        });
      }
      p == null || p(k, K);
    }), h(x(e), "onNodeLoad", function(t) {
      var n, o = t.key, l = e.state.keyEntities, c = V(l, o);
      if (!(c != null && (n = c.children) !== null && n !== void 0 && n.length)) {
        var f = new Promise(function(v, g) {
          e.setState(function(y) {
            var p = y.loadedKeys, m = p === void 0 ? [] : p, k = y.loadingKeys, K = k === void 0 ? [] : k, N = e.props, E = N.loadData, w = N.onLoad;
            if (!E || m.indexOf(o) !== -1 || K.indexOf(o) !== -1)
              return null;
            var P = E(t);
            return P.then(function() {
              var D = e.state.loadedKeys, C = Q(D, o);
              w == null || w(C, {
                event: "load",
                node: t
              }), e.setUncontrolledState({
                loadedKeys: C
              }), e.setState(function(S) {
                return {
                  loadingKeys: X(S.loadingKeys, o)
                };
              }), v();
            }).catch(function(D) {
              if (e.setState(function(S) {
                return {
                  loadingKeys: X(S.loadingKeys, o)
                };
              }), e.loadingRetryTimes[o] = (e.loadingRetryTimes[o] || 0) + 1, e.loadingRetryTimes[o] >= bn) {
                var C = e.state.loadedKeys;
                G(!1, "Retry for `loadData` many times but still failed. No more retry."), e.setUncontrolledState({
                  loadedKeys: Q(C, o)
                }), v();
              }
              g(D);
            }), {
              loadingKeys: Q(K, o)
            };
          });
        });
        return f.catch(function() {
        }), f;
      }
    }), h(x(e), "onNodeMouseEnter", function(t, n) {
      var o = e.props.onMouseEnter;
      o == null || o({
        event: t,
        node: n
      });
    }), h(x(e), "onNodeMouseLeave", function(t, n) {
      var o = e.props.onMouseLeave;
      o == null || o({
        event: t,
        node: n
      });
    }), h(x(e), "onNodeContextMenu", function(t, n) {
      var o = e.props.onRightClick;
      o && (t.preventDefault(), o({
        event: t,
        node: n
      }));
    }), h(x(e), "onFocus", function() {
      var t = e.props.onFocus;
      e.setState({
        focused: !0
      });
      for (var n = arguments.length, o = new Array(n), l = 0; l < n; l++)
        o[l] = arguments[l];
      t == null || t.apply(void 0, o);
    }), h(x(e), "onBlur", function() {
      var t = e.props.onBlur;
      e.setState({
        focused: !1
      }), e.onActiveChange(null);
      for (var n = arguments.length, o = new Array(n), l = 0; l < n; l++)
        o[l] = arguments[l];
      t == null || t.apply(void 0, o);
    }), h(x(e), "getTreeNodeRequiredProps", function() {
      var t = e.state, n = t.expandedKeys, o = t.selectedKeys, l = t.loadedKeys, c = t.loadingKeys, f = t.checkedKeys, v = t.halfCheckedKeys, g = t.dragOverNodeKey, y = t.dropPosition, p = t.keyEntities;
      return {
        expandedKeys: n || [],
        selectedKeys: o || [],
        loadedKeys: l || [],
        loadingKeys: c || [],
        checkedKeys: f || [],
        halfCheckedKeys: v || [],
        dragOverNodeKey: g,
        dropPosition: y,
        keyEntities: p
      };
    }), h(x(e), "setExpandedKeys", function(t) {
      var n = e.state, o = n.treeData, l = n.fieldNames, c = Oe(o, t, l);
      e.setUncontrolledState({
        expandedKeys: t,
        flattenNodes: c
      }, !0);
    }), h(x(e), "onNodeExpand", function(t, n) {
      var o = e.state.expandedKeys, l = e.state, c = l.listChanging, f = l.fieldNames, v = e.props, g = v.onExpand, y = v.loadData, p = n.expanded, m = n[f.key];
      if (!c) {
        var k = o.indexOf(m), K = !p;
        if (G(p && k !== -1 || !p && k === -1, "Expand state not sync with index check"), K ? o = Q(o, m) : o = X(o, m), e.setExpandedKeys(o), g == null || g(o, {
          node: n,
          expanded: K,
          nativeEvent: t.nativeEvent
        }), K && y) {
          var N = e.onNodeLoad(n);
          N && N.then(function() {
            var E = Oe(e.state.treeData, o, f);
            e.setUncontrolledState({
              flattenNodes: E
            });
          }).catch(function() {
            var E = e.state.expandedKeys, w = X(E, m);
            e.setExpandedKeys(w);
          });
        }
      }
    }), h(x(e), "onListChangeStart", function() {
      e.setUncontrolledState({
        listChanging: !0
      });
    }), h(x(e), "onListChangeEnd", function() {
      setTimeout(function() {
        e.setUncontrolledState({
          listChanging: !1
        });
      });
    }), h(x(e), "onActiveChange", function(t) {
      var n = e.state.activeKey, o = e.props, l = o.onActiveChange, c = o.itemScrollOffset, f = c === void 0 ? 0 : c;
      n !== t && (e.setState({
        activeKey: t
      }), t !== null && e.scrollTo({
        key: t,
        offset: f
      }), l == null || l(t));
    }), h(x(e), "getActiveItem", function() {
      var t = e.state, n = t.activeKey, o = t.flattenNodes;
      return n === null ? null : o.find(function(l) {
        var c = l.key;
        return c === n;
      }) || null;
    }), h(x(e), "offsetActiveKey", function(t) {
      var n = e.state, o = n.flattenNodes, l = n.activeKey, c = o.findIndex(function(g) {
        var y = g.key;
        return y === l;
      });
      c === -1 && t < 0 && (c = o.length), c = (c + t + o.length) % o.length;
      var f = o[c];
      if (f) {
        var v = f.key;
        e.onActiveChange(v);
      } else
        e.onActiveChange(null);
    }), h(x(e), "onKeyDown", function(t) {
      var n = e.state, o = n.activeKey, l = n.expandedKeys, c = n.checkedKeys, f = n.fieldNames, v = e.props, g = v.onKeyDown, y = v.checkable, p = v.selectable;
      switch (t.which) {
        case ue.UP: {
          e.offsetActiveKey(-1), t.preventDefault();
          break;
        }
        case ue.DOWN: {
          e.offsetActiveKey(1), t.preventDefault();
          break;
        }
      }
      var m = e.getActiveItem();
      if (m && m.data) {
        var k = e.getTreeNodeRequiredProps(), K = m.data.isLeaf === !1 || !!(m.data[f.children] || []).length, N = A(F(F({}, ye(o, k)), {}, {
          data: m.data,
          active: !0
        }));
        switch (t.which) {
          case ue.LEFT: {
            K && l.includes(o) ? e.onNodeExpand({}, N) : m.parent && e.onActiveChange(m.parent.key), t.preventDefault();
            break;
          }
          case ue.RIGHT: {
            K && !l.includes(o) ? e.onNodeExpand({}, N) : m.children && m.children.length && e.onActiveChange(m.children[0].key), t.preventDefault();
            break;
          }
          case ue.ENTER:
          case ue.SPACE: {
            y && !N.disabled && N.checkable !== !1 && !N.disableCheckbox ? e.onNodeCheck({}, N, !c.includes(o)) : !y && p && !N.disabled && N.selectable !== !1 && e.onNodeSelect({}, N);
            break;
          }
        }
      }
      g == null || g(t);
    }), h(x(e), "setUncontrolledState", function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!e.destroyed) {
        var l = !1, c = !0, f = {};
        Object.keys(t).forEach(function(v) {
          if (v in e.props) {
            c = !1;
            return;
          }
          l = !0, f[v] = t[v];
        }), l && (!n || c) && e.setState(F(F({}, f), o));
      }
    }), h(x(e), "scrollTo", function(t) {
      e.listRef.current.scrollTo(t);
    }), e;
  }
  return lt(i, [{
    key: "componentDidMount",
    value: function() {
      this.destroyed = !1, this.onUpdated();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.onUpdated();
    }
  }, {
    key: "onUpdated",
    value: function() {
      var d = this.props, s = d.activeKey, u = d.itemScrollOffset, t = u === void 0 ? 0 : u;
      s !== void 0 && s !== this.state.activeKey && (this.setState({
        activeKey: s
      }), s !== null && this.scrollTo({
        key: s,
        offset: t
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      window.removeEventListener("dragend", this.onWindowDragEnd), this.destroyed = !0;
    }
  }, {
    key: "resetDragState",
    value: function() {
      this.setState({
        dragOverNodeKey: null,
        dropPosition: null,
        dropLevelOffset: null,
        dropTargetKey: null,
        dropContainerKey: null,
        dropTargetPos: null,
        dropAllowed: !1
      });
    }
  }, {
    key: "render",
    value: function() {
      var d = this.state, s = d.focused, u = d.flattenNodes, t = d.keyEntities, n = d.draggingNodeKey, o = d.activeKey, l = d.dropLevelOffset, c = d.dropContainerKey, f = d.dropTargetKey, v = d.dropPosition, g = d.dragOverNodeKey, y = d.indent, p = this.props, m = p.prefixCls, k = p.className, K = p.style, N = p.showLine, E = p.focusable, w = p.tabIndex, P = w === void 0 ? 0 : w, D = p.selectable, C = p.showIcon, S = p.icon, T = p.switcherIcon, O = p.draggable, I = p.checkable, $ = p.checkStrictly, L = p.disabled, R = p.motion, M = p.loadData, q = p.filterTreeNode, ee = p.height, H = p.itemHeight, z = p.virtual, U = p.titleRender, te = p.dropIndicatorRender, ve = p.onContextMenu, be = p.onScroll, Ee = p.direction, se = p.rootClassName, Ce = p.rootStyle, Ke = ut(this.props, {
        aria: !0,
        data: !0
      }), le;
      return O && (Re(O) === "object" ? le = O : typeof O == "function" ? le = {
        nodeDraggable: O
      } : le = {}), /* @__PURE__ */ b.createElement(_e.Provider, {
        value: {
          prefixCls: m,
          selectable: D,
          showIcon: C,
          icon: S,
          switcherIcon: T,
          draggable: le,
          draggingNodeKey: n,
          checkable: I,
          checkStrictly: $,
          disabled: L,
          keyEntities: t,
          dropLevelOffset: l,
          dropContainerKey: c,
          dropTargetKey: f,
          dropPosition: v,
          dragOverNodeKey: g,
          indent: y,
          direction: Ee,
          dropIndicatorRender: te,
          loadData: M,
          filterTreeNode: q,
          titleRender: U,
          onNodeClick: this.onNodeClick,
          onNodeDoubleClick: this.onNodeDoubleClick,
          onNodeExpand: this.onNodeExpand,
          onNodeSelect: this.onNodeSelect,
          onNodeCheck: this.onNodeCheck,
          onNodeLoad: this.onNodeLoad,
          onNodeMouseEnter: this.onNodeMouseEnter,
          onNodeMouseLeave: this.onNodeMouseLeave,
          onNodeContextMenu: this.onNodeContextMenu,
          onNodeDragStart: this.onNodeDragStart,
          onNodeDragEnter: this.onNodeDragEnter,
          onNodeDragOver: this.onNodeDragOver,
          onNodeDragLeave: this.onNodeDragLeave,
          onNodeDragEnd: this.onNodeDragEnd,
          onNodeDrop: this.onNodeDrop
        }
      }, /* @__PURE__ */ b.createElement("div", {
        role: "tree",
        className: j(m, k, se, h(h(h({}, "".concat(m, "-show-line"), N), "".concat(m, "-focused"), s), "".concat(m, "-active-focused"), o !== null)),
        style: Ce
      }, /* @__PURE__ */ b.createElement(bt, B({
        ref: this.listRef,
        prefixCls: m,
        style: K,
        data: u,
        disabled: L,
        selectable: D,
        checkable: !!I,
        motion: R,
        dragging: n !== null,
        height: ee,
        itemHeight: H,
        virtual: z,
        focusable: E,
        focused: s,
        tabIndex: P,
        activeItem: this.getActiveItem(),
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        onActiveChange: this.onActiveChange,
        onListChangeStart: this.onListChangeStart,
        onListChangeEnd: this.onListChangeEnd,
        onContextMenu: ve,
        onScroll: be
      }, this.getTreeNodeRequiredProps(), Ke))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(d, s) {
      var u = s.prevProps, t = {
        prevProps: d
      };
      function n(w) {
        return !u && w in d || u && u[w] !== d[w];
      }
      var o, l = s.fieldNames;
      if (n("fieldNames") && (l = fe(d.fieldNames), t.fieldNames = l), n("treeData") ? o = d.treeData : n("children") && (G(!1, "`children` of Tree is deprecated. Please use `treeData` instead."), o = pt(d.children)), o) {
        t.treeData = o;
        var c = vt(o, {
          fieldNames: l
        });
        t.keyEntities = F(h({}, ie, mt), c.keyEntities), process.env.NODE_ENV !== "production" && Jt(o, l);
      }
      var f = t.keyEntities || s.keyEntities;
      if (n("expandedKeys") || u && n("autoExpandParent"))
        t.expandedKeys = d.autoExpandParent || !u && d.defaultExpandParent ? Ie(d.expandedKeys, f) : d.expandedKeys;
      else if (!u && d.defaultExpandAll) {
        var v = F({}, f);
        delete v[ie], t.expandedKeys = Object.keys(v).map(function(w) {
          return v[w].key;
        });
      } else
        !u && d.defaultExpandedKeys && (t.expandedKeys = d.autoExpandParent || d.defaultExpandParent ? Ie(d.defaultExpandedKeys, f) : d.defaultExpandedKeys);
      if (t.expandedKeys || delete t.expandedKeys, o || t.expandedKeys) {
        var g = Oe(o || s.treeData, t.expandedKeys || s.expandedKeys, l);
        t.flattenNodes = g;
      }
      if (d.selectable && (n("selectedKeys") ? t.selectedKeys = Xe(d.selectedKeys, d) : !u && d.defaultSelectedKeys && (t.selectedKeys = Xe(d.defaultSelectedKeys, d))), d.checkable) {
        var y;
        if (n("checkedKeys") ? y = Pe(d.checkedKeys) || {} : !u && d.defaultCheckedKeys ? y = Pe(d.defaultCheckedKeys) || {} : o && (y = Pe(d.checkedKeys) || {
          checkedKeys: s.checkedKeys,
          halfCheckedKeys: s.halfCheckedKeys
        }), y) {
          var p = y, m = p.checkedKeys, k = m === void 0 ? [] : m, K = p.halfCheckedKeys, N = K === void 0 ? [] : K;
          if (!d.checkStrictly) {
            var E = $e(k, !0, f);
            k = E.checkedKeys, N = E.halfCheckedKeys;
          }
          t.checkedKeys = k, t.halfCheckedKeys = N;
        }
      }
      return n("loadedKeys") && (t.loadedKeys = d.loadedKeys), t;
    }
  }]), i;
}(b.Component);
h(He, "defaultProps", {
  prefixCls: "rc-tree",
  showLine: !1,
  showIcon: !0,
  selectable: !0,
  multiple: !1,
  checkable: !1,
  disabled: !1,
  checkStrictly: !1,
  draggable: !1,
  defaultExpandParent: !0,
  autoExpandParent: !1,
  defaultExpandAll: !1,
  defaultExpandedKeys: [],
  defaultCheckedKeys: [],
  defaultSelectedKeys: [],
  dropIndicatorRender: un,
  allowDrop: function() {
    return !0;
  },
  expandAction: !1
});
h(He, "TreeNode", pe);
var Kn = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, name: "file", theme: "outlined" };
const xn = Kn;
var Nn = function(r, i) {
  return /* @__PURE__ */ b.createElement(de, B({}, r, {
    ref: i,
    icon: xn
  }));
}, Kt = /* @__PURE__ */ b.forwardRef(Nn);
process.env.NODE_ENV !== "production" && (Kt.displayName = "FileOutlined");
const xt = Kt;
var kn = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" } }] }, name: "folder-open", theme: "outlined" };
const En = kn;
var Cn = function(r, i) {
  return /* @__PURE__ */ b.createElement(de, B({}, r, {
    ref: i,
    icon: En
  }));
}, Nt = /* @__PURE__ */ b.forwardRef(Cn);
process.env.NODE_ENV !== "production" && (Nt.displayName = "FolderOpenOutlined");
const Sn = Nt;
var Dn = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, name: "folder", theme: "outlined" };
const wn = Dn;
var On = function(r, i) {
  return /* @__PURE__ */ b.createElement(de, B({}, r, {
    ref: i,
    icon: wn
  }));
}, kt = /* @__PURE__ */ b.forwardRef(On);
process.env.NODE_ENV !== "production" && (kt.displayName = "FolderOutlined");
const $n = kt;
var Pn = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z" } }] }, name: "holder", theme: "outlined" };
const Tn = Pn;
var Mn = function(r, i) {
  return /* @__PURE__ */ b.createElement(de, B({}, r, {
    ref: i,
    icon: Tn
  }));
}, Et = /* @__PURE__ */ b.forwardRef(Mn);
process.env.NODE_ENV !== "production" && (Et.displayName = "HolderOutlined");
const In = Et, Ln = new zt("ant-tree-node-fx-do-not-use", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), Rn = (a, r) => ({
  [`.${a}-switcher-icon`]: {
    display: "inline-block",
    fontSize: 10,
    verticalAlign: "baseline",
    svg: {
      transition: `transform ${r.motionDurationSlow}`
    }
  }
}), _n = (a, r) => ({
  [`.${a}-drop-indicator`]: {
    position: "absolute",
    // it should displayed over the following node
    zIndex: 1,
    height: 2,
    backgroundColor: r.colorPrimary,
    borderRadius: 1,
    pointerEvents: "none",
    "&:after": {
      position: "absolute",
      top: -3,
      insetInlineStart: -6,
      width: 8,
      height: 8,
      backgroundColor: "transparent",
      border: `${Y(r.lineWidthBold)} solid ${r.colorPrimary}`,
      borderRadius: "50%",
      content: '""'
    }
  }
}), An = (a, r) => {
  const {
    treeCls: i,
    treeNodeCls: e,
    treeNodePadding: d,
    titleHeight: s,
    nodeSelectedBg: u,
    nodeHoverBg: t
  } = r, n = r.paddingXS;
  return {
    [i]: Object.assign(Object.assign({}, At(r)), {
      background: r.colorBgContainer,
      borderRadius: r.borderRadius,
      transition: `background-color ${r.motionDurationSlow}`,
      [`&${i}-rtl`]: {
        // >>> Switcher
        [`${i}-switcher`]: {
          "&_close": {
            [`${i}-switcher-icon`]: {
              svg: {
                transform: "rotate(90deg)"
              }
            }
          }
        }
      },
      [`&-focused:not(:hover):not(${i}-active-focused)`]: Object.assign({}, Ht(r)),
      // =================== Virtual List ===================
      [`${i}-list-holder-inner`]: {
        alignItems: "flex-start"
      },
      [`&${i}-block-node`]: {
        [`${i}-list-holder-inner`]: {
          alignItems: "stretch",
          // >>> Title
          [`${i}-node-content-wrapper`]: {
            flex: "auto"
          },
          // >>> Drag
          [`${e}.dragging`]: {
            position: "relative",
            "&:after": {
              position: "absolute",
              top: 0,
              insetInlineEnd: 0,
              bottom: d,
              insetInlineStart: 0,
              border: `1px solid ${r.colorPrimary}`,
              opacity: 0,
              animationName: Ln,
              animationDuration: r.motionDurationSlow,
              animationPlayState: "running",
              animationFillMode: "forwards",
              content: '""',
              pointerEvents: "none"
            }
          }
        }
      },
      // ===================== TreeNode =====================
      [`${e}`]: {
        display: "flex",
        alignItems: "flex-start",
        padding: `0 0 ${Y(d)} 0`,
        outline: "none",
        "&-rtl": {
          direction: "rtl"
        },
        // Disabled
        "&-disabled": {
          // >>> Title
          [`${i}-node-content-wrapper`]: {
            color: r.colorTextDisabled,
            cursor: "not-allowed",
            "&:hover": {
              background: "transparent"
            }
          }
        },
        [`&-active ${i}-node-content-wrapper`]: {
          background: r.controlItemBgHover
        },
        [`&:not(${e}-disabled).filter-node ${i}-title`]: {
          color: "inherit",
          fontWeight: 500
        },
        "&-draggable": {
          cursor: "grab",
          [`${i}-draggable-icon`]: {
            // https://github.com/ant-design/ant-design/issues/41915
            flexShrink: 0,
            width: s,
            lineHeight: `${Y(s)}`,
            textAlign: "center",
            visibility: "visible",
            opacity: 0.2,
            transition: `opacity ${r.motionDurationSlow}`,
            [`${e}:hover &`]: {
              opacity: 0.45
            }
          },
          [`&${e}-disabled`]: {
            [`${i}-draggable-icon`]: {
              visibility: "hidden"
            }
          }
        }
      },
      // >>> Indent
      [`${i}-indent`]: {
        alignSelf: "stretch",
        whiteSpace: "nowrap",
        userSelect: "none",
        "&-unit": {
          display: "inline-block",
          width: s
        }
      },
      // >>> Drag Handler
      [`${i}-draggable-icon`]: {
        visibility: "hidden"
      },
      // >>> Switcher
      [`${i}-switcher`]: Object.assign(Object.assign({}, Rn(a, r)), {
        position: "relative",
        flex: "none",
        alignSelf: "stretch",
        width: s,
        margin: 0,
        lineHeight: `${Y(s)}`,
        textAlign: "center",
        cursor: "pointer",
        userSelect: "none",
        transition: `all ${r.motionDurationSlow}`,
        borderRadius: r.borderRadius,
        "&-noop": {
          cursor: "unset"
        },
        [`&:not(${i}-switcher-noop):hover`]: {
          backgroundColor: r.colorBgTextHover
        },
        "&_close": {
          [`${i}-switcher-icon`]: {
            svg: {
              transform: "rotate(-90deg)"
            }
          }
        },
        "&-loading-icon": {
          color: r.colorPrimary
        },
        "&-leaf-line": {
          position: "relative",
          zIndex: 1,
          display: "inline-block",
          width: "100%",
          height: "100%",
          // https://github.com/ant-design/ant-design/issues/31884
          "&:before": {
            position: "absolute",
            top: 0,
            insetInlineEnd: r.calc(s).div(2).equal(),
            bottom: r.calc(d).mul(-1).equal(),
            marginInlineStart: -1,
            borderInlineEnd: `1px solid ${r.colorBorder}`,
            content: '""'
          },
          "&:after": {
            position: "absolute",
            width: r.calc(r.calc(s).div(2).equal()).mul(0.8).equal(),
            height: r.calc(s).div(2).equal(),
            borderBottom: `1px solid ${r.colorBorder}`,
            content: '""'
          }
        }
      }),
      // >>> Checkbox
      [`${i}-checkbox`]: {
        top: "initial",
        marginInlineEnd: n,
        alignSelf: "flex-start",
        marginTop: r.marginXXS
      },
      // >>> Title
      // add `${treeCls}-checkbox + span` to cover checkbox `${checkboxCls} + span`
      [`${i}-node-content-wrapper, ${i}-checkbox + span`]: {
        position: "relative",
        zIndex: "auto",
        minHeight: s,
        margin: 0,
        padding: `0 ${Y(r.calc(r.paddingXS).div(2).equal())}`,
        color: "inherit",
        lineHeight: `${Y(s)}`,
        background: "transparent",
        borderRadius: r.borderRadius,
        cursor: "pointer",
        transition: `all ${r.motionDurationMid}, border 0s, line-height 0s, box-shadow 0s`,
        "&:hover": {
          backgroundColor: t
        },
        [`&${i}-node-selected`]: {
          backgroundColor: u
        },
        // Icon
        [`${i}-iconEle`]: {
          display: "inline-block",
          width: s,
          height: s,
          lineHeight: `${Y(s)}`,
          textAlign: "center",
          verticalAlign: "top",
          "&:empty": {
            display: "none"
          }
        }
      },
      // https://github.com/ant-design/ant-design/issues/28217
      [`${i}-unselectable ${i}-node-content-wrapper:hover`]: {
        backgroundColor: "transparent"
      },
      // ==================== Draggable =====================
      [`${i}-node-content-wrapper`]: Object.assign({
        lineHeight: `${Y(s)}`,
        userSelect: "none"
      }, _n(a, r)),
      [`${e}.drop-container`]: {
        "> [draggable]": {
          boxShadow: `0 0 0 2px ${r.colorPrimary}`
        }
      },
      // ==================== Show Line =====================
      "&-show-line": {
        // ================ Indent lines ================
        [`${i}-indent`]: {
          "&-unit": {
            position: "relative",
            height: "100%",
            "&:before": {
              position: "absolute",
              top: 0,
              insetInlineEnd: r.calc(s).div(2).equal(),
              bottom: r.calc(d).mul(-1).equal(),
              borderInlineEnd: `1px solid ${r.colorBorder}`,
              content: '""'
            },
            "&-end": {
              "&:before": {
                display: "none"
              }
            }
          }
        },
        // ============== Cover Background ==============
        [`${i}-switcher`]: {
          background: "transparent",
          "&-line-icon": {
            // https://github.com/ant-design/ant-design/issues/32813
            verticalAlign: "-0.15em"
          }
        }
      },
      [`${e}-leaf-last`]: {
        [`${i}-switcher`]: {
          "&-leaf-line": {
            "&:before": {
              top: "auto !important",
              bottom: "auto !important",
              height: `${Y(r.calc(s).div(2).equal())} !important`
            }
          }
        }
      }
    })
  };
}, Hn = (a) => {
  const {
    treeCls: r,
    treeNodeCls: i,
    treeNodePadding: e,
    directoryNodeSelectedBg: d,
    directoryNodeSelectedColor: s
  } = a;
  return {
    [`${r}${r}-directory`]: {
      // ================== TreeNode ==================
      [i]: {
        position: "relative",
        // Hover color
        "&:before": {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: e,
          insetInlineStart: 0,
          transition: `background-color ${a.motionDurationMid}`,
          content: '""',
          pointerEvents: "none"
        },
        "&:hover": {
          "&:before": {
            background: a.controlItemBgHover
          }
        },
        // Elements
        "> *": {
          zIndex: 1
        },
        // >>> Switcher
        [`${r}-switcher`]: {
          transition: `color ${a.motionDurationMid}`
        },
        // >>> Title
        [`${r}-node-content-wrapper`]: {
          borderRadius: 0,
          userSelect: "none",
          "&:hover": {
            background: "transparent"
          },
          [`&${r}-node-selected`]: {
            color: s,
            background: "transparent"
          }
        },
        // ============= Selected =============
        "&-selected": {
          "\n            &:hover::before,\n            &::before\n          ": {
            background: d
          },
          // >>> Switcher
          [`${r}-switcher`]: {
            color: s
          },
          // >>> Title
          [`${r}-node-content-wrapper`]: {
            color: s,
            background: "transparent"
          }
        }
      }
    }
  };
}, Fn = (a, r) => {
  const i = `.${a}`, e = `${i}-treenode`, d = r.calc(r.paddingXS).div(2).equal(), s = _t(r, {
    treeCls: i,
    treeNodeCls: e,
    treeNodePadding: d
  });
  return [
    // Basic
    An(a, s),
    // Directory
    Hn(s)
  ];
}, Bn = (a) => {
  const {
    controlHeightSM: r
  } = a;
  return {
    titleHeight: r,
    nodeHoverBg: a.controlItemBgHover,
    nodeSelectedBg: a.controlItemBgActive
  };
}, jn = (a) => {
  const {
    colorTextLightSolid: r,
    colorPrimary: i
  } = a;
  return Object.assign(Object.assign({}, Bn(a)), {
    directoryNodeSelectedColor: r,
    directoryNodeSelectedBg: i
  });
}, Vn = Rt("Tree", (a, r) => {
  let {
    prefixCls: i
  } = r;
  return [{
    [a.componentCls]: Ut(`${i}-checkbox`, a)
  }, Fn(i, a), Gt(a)];
}, jn), tt = 4;
function qn(a) {
  const {
    dropPosition: r,
    dropLevelOffset: i,
    prefixCls: e,
    indent: d,
    direction: s = "ltr"
  } = a, u = s === "ltr" ? "left" : "right", t = s === "ltr" ? "right" : "left", n = {
    [u]: -i * d + tt,
    [t]: 0
  };
  switch (r) {
    case -1:
      n.top = -3;
      break;
    case 1:
      n.bottom = -3;
      break;
    default:
      n.bottom = -3, n[u] = d + tt;
      break;
  }
  return /* @__PURE__ */ Z.createElement("div", {
    style: n,
    className: `${e}-drop-indicator`
  });
}
var zn = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, name: "caret-down", theme: "filled" };
const Un = zn;
var Gn = function(r, i) {
  return /* @__PURE__ */ b.createElement(de, B({}, r, {
    ref: i,
    icon: Un
  }));
}, Ct = /* @__PURE__ */ b.forwardRef(Gn);
process.env.NODE_ENV !== "production" && (Ct.displayName = "CaretDownFilled");
const Wn = Ct;
var Xn = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { tag: "path", attrs: { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "minus-square", theme: "outlined" };
const Yn = Xn;
var Jn = function(r, i) {
  return /* @__PURE__ */ b.createElement(de, B({}, r, {
    ref: i,
    icon: Yn
  }));
}, St = /* @__PURE__ */ b.forwardRef(Jn);
process.env.NODE_ENV !== "production" && (St.displayName = "MinusSquareOutlined");
const Qn = St;
var Zn = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { tag: "path", attrs: { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "plus-square", theme: "outlined" };
const er = Zn;
var tr = function(r, i) {
  return /* @__PURE__ */ b.createElement(de, B({}, r, {
    ref: i,
    icon: er
  }));
}, Dt = /* @__PURE__ */ b.forwardRef(tr);
process.env.NODE_ENV !== "production" && (Dt.displayName = "PlusSquareOutlined");
const nr = Dt, rr = (a) => {
  const {
    prefixCls: r,
    switcherIcon: i,
    treeNodeProps: e,
    showLine: d
  } = a, {
    isLeaf: s,
    expanded: u,
    loading: t
  } = e;
  if (t)
    return /* @__PURE__ */ b.createElement(Wt, {
      className: `${r}-switcher-loading-icon`
    });
  let n;
  if (d && typeof d == "object" && (n = d.showLeafIcon), s) {
    if (!d)
      return null;
    if (typeof n != "boolean" && n) {
      const c = typeof n == "function" ? n(e) : n, f = `${r}-switcher-line-custom-icon`;
      return /* @__PURE__ */ b.isValidElement(c) ? ze(c, {
        className: j(c.props.className || "", f)
      }) : c;
    }
    return n ? /* @__PURE__ */ b.createElement(xt, {
      className: `${r}-switcher-line-icon`
    }) : /* @__PURE__ */ b.createElement("span", {
      className: `${r}-switcher-leaf-line`
    });
  }
  const o = `${r}-switcher-icon`, l = typeof i == "function" ? i(e) : i;
  return /* @__PURE__ */ b.isValidElement(l) ? ze(l, {
    className: j(l.props.className || "", o)
  }) : l !== void 0 ? l : d ? u ? /* @__PURE__ */ b.createElement(Qn, {
    className: `${r}-switcher-line-icon`
  }) : /* @__PURE__ */ b.createElement(nr, {
    className: `${r}-switcher-line-icon`
  }) : /* @__PURE__ */ b.createElement(Wn, {
    className: o
  });
}, ar = rr, wt = /* @__PURE__ */ Z.forwardRef((a, r) => {
  var i;
  const {
    getPrefixCls: e,
    direction: d,
    virtual: s,
    tree: u
  } = Z.useContext(ct), {
    prefixCls: t,
    className: n,
    showIcon: o = !1,
    showLine: l,
    switcherIcon: c,
    blockNode: f = !1,
    children: v,
    checkable: g = !1,
    selectable: y = !0,
    draggable: p,
    motion: m,
    style: k
  } = a, K = e("tree", t), N = e(), E = m ?? Object.assign(Object.assign({}, Bt(N)), {
    motionAppear: !1
  }), w = Object.assign(Object.assign({}, a), {
    checkable: g,
    selectable: y,
    showIcon: o,
    motion: E,
    blockNode: f,
    showLine: !!l,
    dropIndicatorRender: qn
  }), [P, D, C] = Vn(K), [, S] = Ft(), T = S.paddingXS / 2 + (((i = S.Tree) === null || i === void 0 ? void 0 : i.titleHeight) || S.controlHeightSM), O = Z.useMemo(() => {
    if (!p)
      return !1;
    let $ = {};
    switch (typeof p) {
      case "function":
        $.nodeDraggable = p;
        break;
      case "object":
        $ = Object.assign({}, p);
        break;
    }
    return $.icon !== !1 && ($.icon = $.icon || /* @__PURE__ */ Z.createElement(In, null)), $;
  }, [p]), I = ($) => /* @__PURE__ */ Z.createElement(ar, {
    prefixCls: K,
    switcherIcon: c,
    treeNodeProps: $,
    showLine: l
  });
  return P(
    // @ts-ignore
    /* @__PURE__ */ Z.createElement(He, Object.assign({
      itemHeight: T,
      ref: r,
      virtual: s
    }, w, {
      // newProps may contain style so declare style below it
      style: Object.assign(Object.assign({}, u == null ? void 0 : u.style), k),
      prefixCls: K,
      className: j({
        [`${K}-icon-hide`]: !o,
        [`${K}-block-node`]: f,
        [`${K}-unselectable`]: !y,
        [`${K}-rtl`]: d === "rtl"
      }, u == null ? void 0 : u.className, n, D, C),
      direction: d,
      checkable: g && /* @__PURE__ */ Z.createElement("span", {
        className: `${K}-checkbox-inner`
      }),
      selectable: y,
      switcherIcon: I,
      draggable: O
    }), v)
  );
});
process.env.NODE_ENV !== "production" && (wt.displayName = "Tree");
const Ot = wt, nt = 0, Te = 1, rt = 2;
function Fe(a, r, i) {
  const {
    key: e,
    children: d
  } = i;
  function s(u) {
    const t = u[e], n = u[d];
    r(t, u) !== !1 && Fe(n || [], r, i);
  }
  a.forEach(s);
}
function or(a) {
  let {
    treeData: r,
    expandedKeys: i,
    startKey: e,
    endKey: d,
    fieldNames: s
  } = a;
  const u = [];
  let t = nt;
  if (e && e === d)
    return [e];
  if (!e || !d)
    return [];
  function n(o) {
    return o === e || o === d;
  }
  return Fe(r, (o) => {
    if (t === rt)
      return !1;
    if (n(o)) {
      if (u.push(o), t === nt)
        t = Te;
      else if (t === Te)
        return t = rt, !1;
    } else
      t === Te && u.push(o);
    return i.includes(o);
  }, fe(s)), u;
}
function Me(a, r, i) {
  const e = W(r), d = [];
  return Fe(a, (s, u) => {
    const t = e.indexOf(s);
    return t !== -1 && (d.push(u), e.splice(t, 1)), !!e.length;
  }, fe(i)), d;
}
var at = function(a, r) {
  var i = {};
  for (var e in a)
    Object.prototype.hasOwnProperty.call(a, e) && r.indexOf(e) < 0 && (i[e] = a[e]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var d = 0, e = Object.getOwnPropertySymbols(a); d < e.length; d++)
      r.indexOf(e[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, e[d]) && (i[e[d]] = a[e[d]]);
  return i;
};
function ir(a) {
  const {
    isLeaf: r,
    expanded: i
  } = a;
  return r ? /* @__PURE__ */ b.createElement(xt, null) : i ? /* @__PURE__ */ b.createElement(Sn, null) : /* @__PURE__ */ b.createElement($n, null);
}
function ot(a) {
  let {
    treeData: r,
    children: i
  } = a;
  return r || pt(i);
}
const dr = (a, r) => {
  var {
    defaultExpandAll: i,
    defaultExpandParent: e,
    defaultExpandedKeys: d
  } = a, s = at(a, ["defaultExpandAll", "defaultExpandParent", "defaultExpandedKeys"]);
  const u = b.useRef(), t = b.useRef(), n = () => {
    const {
      keyEntities: D
    } = vt(ot(s));
    let C;
    return i ? C = Object.keys(D) : e ? C = Ie(s.expandedKeys || d || [], D) : C = s.expandedKeys || d || [], C;
  }, [o, l] = b.useState(s.selectedKeys || s.defaultSelectedKeys || []), [c, f] = b.useState(() => n());
  b.useEffect(() => {
    "selectedKeys" in s && l(s.selectedKeys);
  }, [s.selectedKeys]), b.useEffect(() => {
    "expandedKeys" in s && f(s.expandedKeys);
  }, [s.expandedKeys]);
  const v = (D, C) => {
    var S;
    return "expandedKeys" in s || f(D), (S = s.onExpand) === null || S === void 0 ? void 0 : S.call(s, D, C);
  }, g = (D, C) => {
    var S;
    const {
      multiple: T,
      fieldNames: O
    } = s, {
      node: I,
      nativeEvent: $
    } = C, {
      key: L = ""
    } = I, R = ot(s), M = Object.assign(Object.assign({}, C), {
      selected: !0
    }), q = ($ == null ? void 0 : $.ctrlKey) || ($ == null ? void 0 : $.metaKey), ee = $ == null ? void 0 : $.shiftKey;
    let H;
    T && q ? (H = D, u.current = L, t.current = H, M.selectedNodes = Me(R, H, O)) : T && ee ? (H = Array.from(new Set([].concat(W(t.current || []), W(or({
      treeData: R,
      expandedKeys: c,
      startKey: L,
      endKey: u.current,
      fieldNames: O
    }))))), M.selectedNodes = Me(R, H, O)) : (H = [L], u.current = L, t.current = H, M.selectedNodes = Me(R, H, O)), (S = s.onSelect) === null || S === void 0 || S.call(s, H, M), "selectedKeys" in s || l(H);
  }, {
    getPrefixCls: y,
    direction: p
  } = b.useContext(ct), {
    prefixCls: m,
    className: k,
    showIcon: K = !0,
    expandAction: N = "click"
  } = s, E = at(s, ["prefixCls", "className", "showIcon", "expandAction"]), w = y("tree", m), P = j(`${w}-directory`, {
    [`${w}-directory-rtl`]: p === "rtl"
  }, k);
  return /* @__PURE__ */ b.createElement(Ot, Object.assign({
    icon: ir,
    ref: r,
    blockNode: !0
  }, E, {
    showIcon: K,
    expandAction: N,
    prefixCls: w,
    className: P,
    expandedKeys: c,
    selectedKeys: o,
    onSelect: g,
    onExpand: v
  }));
}, $t = /* @__PURE__ */ b.forwardRef(dr);
process.env.NODE_ENV !== "production" && ($t.displayName = "DirectoryTree");
const sr = $t, Be = Ot;
Be.DirectoryTree = sr;
Be.TreeNode = pe;
const lr = Be, Cr = It(lr)`
  &.ant-tree {
    background: transparent !important;
  }

  .ant-tree-title {
    line-height: 1.2;
  }

  .ant-tree-list-holder {
    .ant-tree-indent-unit {
      width: 16px;
    }

    .ant-tree-treenode:not(.ant-tree-treenode-leaf-last) {
      padding-bottom: var(--space-12);
    }

    .ant-tree-treenode-leaf-last + div {
      padding-top: var(--space-12);
    }
  }

  &.ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background-color: transparent; /* Assuming --transparent is a CSS variable */
  }

  ${({
  design: a
}) => a === "border-design" && `css

      .ant-tree-checkbox .ant-tree-checkbox-inner {
        border: 1px solid var(--gray-5);
      }

      .ant-tree-checkbox-checked .ant-tree-checkbox-inner {
        background: var(--gray-1);
        border: 1px solid var(--purple-7);
      }

      .ant-tree-checkbox-checked .ant-tree-checkbox-inner::after {
        border: 1.5px solid var(--primary-7);
        border-top: 0;
        border-left: 0;

        &:hover {
          background: var(--gray-1);
        }
      }

      .ant-tree-checkbox-disabled.ant-tree-checkbox-checked .ant-tree-checkbox-inner {
        background: var(--gray-3);
        border: 1px solid var(--gray-5);
      }

      .ant-tree-checkbox-disabled.ant-tree-checkbox-checked .ant-tree-checkbox-inner::after {
        border-color: var(--gray-6);
      }

      &.ant-tree .ant-tree-checkbox-checked:not(.ant-tree-checkbox-disabled):hover .ant-tree-checkbox-inner {
        background-color: var(--gray-1) !important;
        border-color: var(--primary-7);
      }
    `}
`;
export {
  Cr as StyledTree
};
//# sourceMappingURL=style.js.map
